
import { AssetPreviewTabResultsController } from './asset-preview-tab-results.controller'

function assetPreviewTabResults () {
  return {
    restrict: 'E',
    scope: {
      template: '<'
    },
    templateUrl: '/core/directives/asset-preview-tab-results/asset-preview-tab-results.html?$$REVISION$$',
    controller: AssetPreviewTabResultsController
  }
}
export { assetPreviewTabResults }
